import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NetworkDiagramConfigurationsService {

  constructor() {
  }

  generateNormalSizeConf(addEdgeCall): any {
    return {
      nodes: {
        shape: 'circularImage',
        size: 30,
        borderWidth: 0,
        chosen: {
          node(values, id, selected, hovering) {
            values.borderWidth = 3;
          }
        },
        labelHighlightBold: true,
        font: {
          size: 24
        }
      },
      edges: {
        smooth: {
          enabled: false
        },
        chosen: {
          edge(values, id, selected, hovering) {
            values.shadow = true;
            values.width += 2;
          }
        },
        color: {
          inherit: false
        }
      },
      interaction: {
        hover: true,
        multiselect: true,
        navigationButtons: false,
        selectConnectedEdges: false,
        hideEdgesOnDrag: false
      },
      physics: {
        enabled: false
      },
      manipulation: {
        enabled: false,
        addNode(nodeData, callback) {
          nodeData.label = 'hello world';
          callback(nodeData);
        },
        addEdge: (edgeData, callback) => {
          if (edgeData.from !== edgeData.to) {
            callback(edgeData);
            // this.sharedEventService.broadcast('EdgeDraggedEvent', edgeData);
            addEdgeCall(edgeData);
          }
        }
      }
    };
  }
}
